import React from "react"
import EditUserProfileForm from "components/templates/EditUserProfileForm"

export default function EditUserProfilePage() {
  return (
    <>
      <EditUserProfileForm/>
    </>
  )
}
